import React from "react";
import { Box, Card, Typography } from "@mui/material";
import { TripStop } from "../../../types/api";
import { datesCard } from "../style";
import { useTranslation } from "react-i18next";
interface TripDatesCardProps {
  tripStop: TripStop;
}

const TripDatesCard: React.FC<TripDatesCardProps> = ({ tripStop }) => {
  function formatApprovalDate(isoDate: string): string {
    const date = new Date(isoDate);

    // Estrarre giorno, mese, anno
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // I mesi vanno da 0 a 11
    const year = date.getFullYear();

    // Estrarre ore e minuti
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  function determineBoxColor(
    actualDate?: string,
    expectedDate?: string
  ): string {
    if (!actualDate || !expectedDate) {
      return "#6F6F6F";
    }

    const actual = new Date(actualDate).getTime();
    const expected = new Date(expectedDate).getTime();

    return actual <= expected ? "#0ACF4D" : "#CF0A2C";
  }

  const departureColor = determineBoxColor(
    tripStop.actualDeparture || undefined,
    tripStop.expectedDeparture || undefined
  );

  const arrivalColor = determineBoxColor(
    tripStop.actualArrival || undefined,
    tripStop.expectedArrival || undefined
  );
  const { t } = useTranslation();
  return (
    <Card
      elevation={0}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        padding: "16px 0 0 0 ",
      }}
    >
        <Box sx={{ marginBottom: "8px" }}>
        <Box sx={datesCard.box1}>
          <Box sx={datesCard.box2}>
            <Box>
              <Typography sx={datesCard.supportText}>
                {t("screens.trips.datesCard.expectedArrival")}
              </Typography>
              <Typography sx={datesCard.value}>
                {tripStop.expectedArrival
                  ? formatApprovalDate(tripStop.expectedArrival)
                  : "-"}
              </Typography>
            </Box>
          </Box>
          <Box sx={datesCard.box2}>
            <Box
              sx={{
                ...datesCard.status,
                backgroundColor: arrivalColor,
              }}
            />
            <Box>
              <Typography sx={datesCard.supportText}>
                {" "}
                {t("screens.trips.datesCard.actualArrival")}
              </Typography>
              <Typography sx={datesCard.value}>
                {tripStop.actualArrival
                  ? formatApprovalDate(tripStop.actualArrival)
                  : "-"}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box >
        <Box sx={datesCard.box1}>
          <Box sx={datesCard.box2}>
            <Box>
              <Typography sx={datesCard.supportText}>
                {t("screens.trips.datesCard.expectedDeparture")}
              </Typography>
              <Typography sx={datesCard.value}>
                {tripStop.expectedDeparture
                  ? formatApprovalDate(tripStop.expectedDeparture)
                  : "-"}
              </Typography>
            </Box>
          </Box>
          <Box sx={datesCard.box2}>
            <Box
              sx={{
                ...datesCard.status,
                backgroundColor: departureColor,
              }}
            />
            <Box>
              <Typography sx={datesCard.supportText}>
                {t("screens.trips.datesCard.actualDeparture")}
              </Typography>
              <Typography sx={datesCard.value}>
                {tripStop.actualDeparture
                  ? formatApprovalDate(tripStop.actualDeparture)
                  : "-"}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    
    </Card>
  );
};

export default TripDatesCard;
